export const siteMeta = {
  siteName: "УрНИИДВиИ",
  siteUrl: "https://urniidvi.ru",
  defaultImage: "https://urniidvi.ru/og-image.jpg",
  organizationName: "Уральский НИИ дерматовенерологии и иммунопатологии",
  shortName: "УрНИИДВиИ",
  phone: "+7 (343) 218-95-86",
  email: "urniidvi-public@mis66.ru",
  address: "620076, Свердловская область, г. Екатеринбург, ул. Щербакова, 8",
  city: "Екатеринбург",
  region: "Свердловская область",
  country: "RU",
};

const seoConfig = {
  home: {
    title: "Уральский НИИ дерматовенерологии и иммунопатологии",
    description:
      "Официальный сайт УрНИИДВиИ: клиника дерматологии, научные исследования, медицинское образование, консультации специалистов и помощь пациентам в Екатеринбурге.",
    keywords:
      "УрНИИДВиИ, дерматология Екатеринбург, дерматовенерология, медицинский институт, кожная клиника",
    url: "/",
  },

  // Об институте
  about: {
    title: "Об институте",
    description:
      "История, структура, руководство, лицензии и официальные сведения о деятельности Уральского НИИ дерматовенерологии и иммунопатологии.",
    keywords: "об институте УрНИИДВиИ, история института, структура УрНИИДВиИ",
    url: "/about",
  },

  history: {
    title: "История института",
    description:
      "Этапы создания, развития и становления института, научные достижения, клиническая работа и образовательная деятельность учреждения.",
    keywords:
      "история УрНИИДВиИ, развитие дерматологического института, научная история института",
    url: "/about/history",
  },

  structure: {
    title: "Структура института",
    description:
      "Научные подразделения, клинические отделения, административные службы и организационная структура учреждения.",
    keywords: "структура УрНИИДВиИ, подразделения института, отделения НИИ",
    url: "/about/structure",
  },

  managers: {
    title: "Руководство института",
    description:
      "Сведения о руководителях, администрации и должностных лицах Уральского НИИ дерматовенерологии и иммунопатологии.",
    keywords: "руководство УрНИИДВиИ, директор института, администрация НИИ",
    url: "/about/managers",
  },

  licenses: {
    title: "Лицензии и правовая информация",
    description:
      "Учредительные документы, лицензии, нормативные сведения и правовая информация о деятельности учреждения.",
    keywords:
      "лицензии УрНИИДВиИ, правовая информация, учредительные документы",
    url: "/about/licenses",
  },

  privacy: {
    title: "Политика конфиденциальности",
    description:
      "Политика обработки, хранения и защиты персональных данных пользователей официального сайта.",
    keywords: "политика конфиденциальности, персональные данные",
    url: "/about/privacy",
    noindex: true,
  },

  antiCorruption: {
    title: "Противодействие коррупции",
    description:
      "Локальные нормативные акты, документы и сведения о мерах по предупреждению коррупции.",
    keywords: "противодействие коррупции, антикоррупционная политика",
    url: "/about/anti-corruption",
  },

  antiTerror: {
    title: "Антитеррористическая безопасность",
    description:
      "Информация о мерах антитеррористической защищенности сотрудников, пациентов и посетителей учреждения.",
    keywords: "антитеррористическая безопасность, защищенность объекта",
    url: "/about/anti-terror",
    noindex: true,
  },

  controls: {
    title: "Органы управления",
    description:
      "Сведения об органах управления, административной структуре и порядке руководства учреждением.",
    keywords: "органы управления, административная структура НИИ",
    url: "/about/controls",
    noindex: true,
  },

  vacancies: {
    title: "Вакансии",
    description:
      "Актуальные вакансии, предложения о трудоустройстве и информация для соискателей в медицинском учреждении.",
    keywords: "вакансии УрНИИДВиИ, работа Екатеринбург медицина",
    url: "/about/vacancies",
  },

  news: {
    title: "Новости института",
    description:
      "Последние новости, научные события, публикации, достижения и официальная информация учреждения.",
    keywords: "новости УрНИИДВиИ, события института, медицинские новости",
    url: "/about/news",
  },

  sitemap: {
    title: "Карта сайта",
    description:
      "Полная структура разделов и страниц официального сайта для удобной навигации пользователей.",
    keywords: "карта сайта УрНИИДВиИ, структура сайта",
    url: "/about/sitemap",
    noindex: true,
  },

  workingConditions: {
    title: "Условия труда",
    description:
      "Сведения об условиях труда, специальной оценке, охране труда и мероприятиях по обеспечению безопасности сотрудников.",
    keywords: "условия труда, охрана труда, СОУТ",
    url: "/about/working-conditions",
    noindex: true,
  },

  accountingPolicy: {
    title: "Учетная политика",
    description:
      "Документы и сведения об учетной политике, бухгалтерском учете и финансовой отчетности учреждения.",
    keywords: "учетная политика, бухгалтерская отчетность",
    url: "/about/accounting-policy",
    noindex: true,
  },

  independentAssessment: {
    title: "Независимая оценка качества",
    description:
      "Результаты независимой оценки качества условий оказания услуг и официальные материалы учреждения.",
    keywords: "независимая оценка качества, качество медицинских услуг",
    url: "/about/independent-assessment",
  },

  heatingSeason: {
    title: "Подготовка к отопительному сезону",
    description:
      "Документы, планы мероприятий и сведения о подготовке инженерной инфраструктуры учреждения.",
    keywords: "отопительный сезон, инженерная подготовка",
    url: "/about/heating-season",
    noindex: true,
  },

  // Наука
  science: {
    title: "Научная деятельность",
    description:
      "Научные исследования, клинические испытания, медицинские разработки и внедрение современных технологий в дерматологии.",
    keywords:
      "научная деятельность УрНИИДВиИ, медицинские исследования, дерматология",
    url: "/science",
  },

  research: {
    title: "Научно-исследовательские разработки",
    description:
      "Фундаментальные и прикладные исследования в области дерматологии, иммунопатологии и дерматовенерологии.",
    keywords:
      "научные исследования дерматология, медицинские разработки, дерматовенерология",
    url: "/science/research",
  },

  development: {
    title: "Медицинские и организационные технологии",
    description:
      "Разработка и внедрение медицинских, диагностических и организационных технологий в систему здравоохранения.",
    keywords:
      "медицинские технологии, организационные технологии, инновации медицина",
    url: "/science/development",
  },

  dissertation: {
    title: "Диссертационный совет",
    description:
      "Защита кандидатских и докторских диссертаций по дерматологии, дерматовенерологии и медицинским наукам.",
    keywords: "диссертационный совет, защита диссертации медицина",
    url: "/science/dissertation",
  },

  videobroadcast: {
    title: "Видеотрансляции защит диссертаций",
    description:
      "Онлайн-видеотрансляции защит кандидатских и докторских диссертаций.",
    keywords: "видеотрансляции защит диссертаций",
    url: "/science/dissertation/videobroadcast",
    noindex: true,
  },

  advertisements: {
    title: "Объявления о защите диссертаций",
    description:
      "Официальные объявления о предстоящих защитах кандидатских и докторских диссертаций.",
    keywords: "объявления защиты диссертаций",
    url: "/science/dissertation/advertisements",
  },

  clinicalTrials: {
    title: "Клинические испытания лекарственных средств",
    description:
      "Оценка эффективности и безопасности лекарственных препаратов, научные исследования и медицинская экспертиза.",
    keywords:
      "клинические испытания, лекарственные средства, медицинские исследования",
    url: "/science/clinical-trials",
  },

  publications: {
    title: "Научные публикации",
    description:
      "Научные статьи, публикации сотрудников, результаты исследований и медицинские материалы.",
    keywords: "научные публикации, медицинские статьи, дерматология",
    url: "/science/publications",
  },

  scientificResearch: {
    title: "Научные исследования в дерматологии",
    description:
      "Изучение заболеваний кожи, диагностика, иммунопатология и современные методы лечения.",
    keywords: "исследования в дерматологии, болезни кожи, дерматовенерология",
    url: "/science/scientific-research",
  },

  certification: {
    title: "Аттестация научных работников",
    description:
      "Оценка квалификации, подтверждение научных достижений и профессионального уровня специалистов.",
    keywords: "аттестация научных работников, научная квалификация",
    url: "/science/certification",
  },

  patents: {
    title:
      "Патенты, сертификаты и регистрационные удостоверения | ГБУ СО «УрНИИДВиИ»",
    description:
      "Патенты, разрешения, сертификаты и регистрационные удостоверения ГБУ СО «УрНИИДВиИ». Ознакомьтесь с официальными документами, научными разработками, результатами интеллектуальной деятельности и разрешительной документацией института.",
    keywords:
      "УрНИИДВиИ, ГБУ СО УрНИИДВиИ, патенты УрНИИДВиИ, сертификаты УрНИИДВиИ, регистрационные удостоверения, разрешения, разрешительная документация, научные разработки, интеллектуальная собственность, медицинские технологии, дерматовенерология, иммунопатология, официальные документы",
    url: "/science/patents",
  },

  // Образование
  education: {
    title: "Медицинское образование в УрНИИДВиИ Екатеринбург",
    description:
      "Ординатура, аспирантура, дополнительное профессиональное образование и подготовка врачей-дерматовенерологов.",
    keywords:
      "медицинское образование Екатеринбург, ординатура дерматология, аспирантура",
    url: "/education",
  },

  residency: {
    title: "Ординатура по дерматовенерологии в Екатеринбурге",
    description:
      "Подготовка врачей-специалистов по дерматовенерологии, клиническая практика и современное медицинское обучение.",
    keywords: "ординатура дерматовенерология Екатеринбург, обучение врачей",
    url: "/education/residency",
  },

  scientificEducational: {
    title: "Научно-образовательный отдел УрНИИДВиИ",
    description:
      "Организация обучения ординаторов, аспирантов и развитие медицинского образования в институте.",
    keywords: "научно-образовательный отдел, обучение ординаторов",
    url: "/education/residency/scientific-educational",
  },

  educationalProgram: {
    title: "Образовательная программа ординатуры",
    description:
      "Учебный план, клиническая практика и теоретическая подготовка врачей-ординаторов.",
    keywords: "образовательная программа ординатуры дерматовенерология",
    url: "/education/residency/educational-program",
  },

  regulatoryDocuments: {
    title: "Нормативные документы ординатуры",
    description:
      "Стандарты, приказы и образовательные требования, регулирующие обучение в ординатуре.",
    keywords: "нормативные документы ординатуры",
    url: "/education/residency/regulatory-documents",
  },

  organizationMonitoring: {
    title: "Мониторинг качества образования",
    description:
      "Оценка учебного процесса и контроль подготовки специалистов в ординатуре.",
    keywords: "мониторинг качества образования медицина",
    url: "/education/residency/organization-monitoring",
  },

  clinicalBase: {
    title: "Клиническая база для обучения ординаторов",
    description:
      "Практическая подготовка врачей на базе современного медицинского учреждения.",
    keywords: "клиническая база ординатуры, практика врачей",
    url: "/education/residency/clinical-base",
  },

  contingentStudents: {
    title: "Контингент обучающихся в ординатуре",
    description:
      "Статистика приема и подготовки специалистов по дерматовенерологии.",
    keywords: "контингент ординаторов, статистика обучения",
    url: "/education/residency/contingent-students",
  },

  postgraduateStudies: {
    title: "Аспирантура по дерматологии в Екатеринбурге",
    description:
      "Подготовка научных кадров в области дерматологии и дерматовенерологии, выполнение диссертационных исследований.",
    keywords: "аспирантура дерматология Екатеринбург, научная подготовка",
    url: "/education/postgraduate-studies",
  },

  additional: {
    title: "Дополнительное образование врачей-дерматовенерологов",
    description:
      "Повышение квалификации и профессиональная переподготовка врачей в области дерматологии.",
    keywords:
      "дополнительное профессиональное образование врачей, повышение квалификации",
    url: "/education/additional",
  },

  advancedTraining: {
    title: "Циклы повышения квалификации врачей",
    description:
      "Современные программы повышения квалификации по диагностике и лечению кожных заболеваний.",
    keywords: "повышение квалификации дерматология",
    url: "/education/additional/advanced-training",
  },

  certificationCycle: {
    title: "Сертификационный цикл для врачей",
    description:
      "Подтверждение квалификации и профессиональная подготовка специалистов.",
    keywords: "сертификационный цикл врачей",
    url: "/education/additional/certification-cycle",
  },

  shortImprovement: {
    title: "Краткосрочные курсы повышения квалификации",
    description:
      "Краткосрочные образовательные программы для актуализации профессиональных знаний врачей.",
    keywords: "краткосрочные курсы врачей, дерматология",
    url: "/education/additional/short-improvement",
  },

  professionalRetraining: {
    title: "Профессиональная переподготовка по косметологии",
    description:
      "Получение новой медицинской квалификации по специальности косметология.",
    keywords: "переподготовка по косметологии, обучение врачей",
    url: "/education/additional/professional-retraining",
  },

  teachingStaff: {
    title: "Профессорско-преподавательский состав",
    description:
      "Профессорско-преподавательский состав УРНИИДВиИ: профессора, доктора и кандидаты медицинских наук, ведущие преподаватели программ ординатуры и дополнительного профессионального образования.",
    keywords:
      "профессорско-преподавательский состав, преподаватели УРНИИДВиИ, преподаватели института, ординатура Екатеринбург, медицинское образование, доктора медицинских наук, кандидаты медицинских наук, преподаватели дерматовенерологии, УРНИИДВиИ",
    url: "/education/teaching-staff",
    noindex: false,
  },

  admissionsCommittee: {
    title: "Приемная комиссия УрНИИДВиИ",
    description:
      "Правила поступления в ординатуру и аспирантуру, перечень документов и требования для абитуриентов.",
    keywords: "приемная комиссия ординатура, поступление аспирантура",
    url: "/education/admissions-committee",
  },

  taxDeduction: {
    title: "Налоговый вычет за обучение",
    description:
      "Порядок оформления налогового вычета за платные образовательные услуги.",
    keywords: "налоговый вычет за обучение медицина",
    url: "/education/tax-deduction",
  },

  // Клиника
  clinic: {
    title: "Клиника дерматологии и дерматовенерологии в Екатеринбурге",
    description:
      "Прием дерматолога и венеролога, диагностика, лечение кожных заболеваний, современные медицинские технологии и консультации специалистов.",
    keywords:
      "дерматолог Екатеринбург, венеролог Екатеринбург, лечение кожных заболеваний",
    url: "/clinic",
  },

  hospital: {
    title: "Высокотехнологичная медицинская помощь",
    description:
      "Диагностика и лечение сложных дерматологических и дерматовенерологических заболеваний с применением современных технологий.",
    keywords: "высокотехнологичная медицинская помощь, сложная дерматология",
    url: "/clinic/hospital",
  },

  specializedMedical: {
    title: "Специализированная медицинская помощь",
    description:
      "Консультации врачей-дерматовенерологов, диагностика, лечение и наблюдение пациентов.",
    keywords: "специализированная медицинская помощь, дерматовенеролог",
    url: "/clinic/specialized-medical",
  },

  workingChief: {
    title: "Кожно-венерологические учреждения области",
    description:
      "Методическая поддержка, взаимодействие и развитие дерматовенерологической службы региона.",
    keywords: "кожно-венерологические учреждения, дерматология область",
    url: "/clinic/working-chief",
  },

  problemSyphilis: {
    title: "Консультативный совет по сифилису",
    description:
      "Диагностика, лечение, профилактика и научное сопровождение борьбы с инфекцией.",
    keywords: "лечение сифилиса, профилактика сифилиса, диагностика сифилиса",
    url: "/clinic/problem-syphilis",
  },

  // Пациентам
  patients: {
    title: "Пациентам",
    description:
      "Запись на прием, медицинские услуги, специалисты, график работы и информация для пациентов клиники.",
    keywords: "пациентам УрНИИДВиИ, запись к врачу, медицинские услуги",
    url: "/patients",
  },

  reception: {
    title: "Прием специалистов",
    description:
      "Прием дерматолога, венеролога, консультации врачей и медицинские осмотры.",
    keywords: "прием дерматолога, прием венеролога",
    url: "/patients/reception",
  },

  receptionOmc: {
    title: "Прием специалистов по ОМС",
    description: "Бесплатная медицинская помощь пациентам по полису ОМС.",
    keywords: "ОМС дерматолог, бесплатный прием врача",
    url: "/patients/reception-omc",
  },

  working: {
    title: "График работы клиники",
    description:
      "Режим работы регистратуры, врачей-специалистов и подразделений клиники.",
    keywords: "график работы клиники, часы приема врачей",
    url: "/patients/working",
  },

  pay: {
    title: "Платные медицинские услуги",
    description:
      "Консультации специалистов, диагностика, лечение и перечень платных медицинских услуг.",
    keywords: "платные медицинские услуги, платный дерматолог",
    url: "/patients/pay",
  },

  priceList: {
    title: "Прейскурант медицинских услуг",
    description:
      "Стоимость консультаций, диагностики, процедур и лечения в клинике.",
    keywords: "цены на медицинские услуги, стоимость приема дерматолога",
    url: "/patients/price-list",
  },

  specialists: {
    title: "Врачи-специалисты",
    description:
      "Квалификация, опыт, специализация и направления работы врачей клиники.",
    keywords: "врачи дерматологи, врачи венерологи",
    url: "/patients/specialists",
  },

  provision: {
    title: "Порядок оказания медицинских услуг",
    description:
      "Правила получения консультаций, диагностики, лечения и медицинской помощи пациентам.",
    keywords: "оказание медицинских услуг, порядок приема пациентов",
    url: "/patients/provision",
  },

  participantsSVO: {
    title: "Медицинская помощь участникам СВО",
    description: "Консультации, диагностика и лечение участников СВО.",
    keywords: "медицинская помощь участникам СВО",
    url: "/patients/participantsSVO",
  },

  accessibleEnvironment: {
    title: "Доступная среда",
    description:
      "Условия для маломобильных пациентов и доступ к медицинским услугам.",
    keywords: "доступная среда клиника",
    url: "/patients/accessible-environment",
  },

  helplines: {
    title: "Телефоны доверия",
    description:
      "Телефоны доверия, справочные службы и полезные контакты для пациентов.",
    keywords: "телефоны доверия медицина",
    url: "/patients/helplines",
  },

  fireSafety: {
    title: "Пожарная безопасность",
    description:
      "Правила и меры пожарной безопасности для пациентов и персонала.",
    keywords: "пожарная безопасность клиника",
    url: "/patients/fire-safety",
  },

  clinicalExamination: {
    title: "Диспансеризация населения",
    description:
      "Профилактические осмотры, раннее выявление заболеваний кожи и медицинские обследования.",
    keywords: "диспансеризация населения, профилактический осмотр",
    url: "/patients/clinical-examination",
  },

  week: {
    title: "Профилактика заболеваний и ЗОЖ",
    description:
      "Профилактика кожных заболеваний, медицинские рекомендации и здоровый образ жизни.",
    keywords: "профилактика заболеваний, ЗОЖ",
    url: "/patients/week",
  },

  gosuurli: {
    title: "Госуслуги в сфере здравоохранения",
    description:
      "Получение медицинских услуг через портал Госуслуг и электронные сервисы записи.",
    keywords: "Госуслуги медицина, запись к врачу онлайн",
    url: "/patients/gosuurli",
  },

  questionAnswer: {
    title: "Вопрос–ответ",
    description:
      "Ответы на частые вопросы пациентов о записи, лечении и медицинских услугах.",
    keywords: "вопрос ответ пациентам",
    url: "/patients/question-answer",
  },

  reviews: {
    title: "Отзывы о врачах УрНИИДВиИ в Екатеринбурге",
    description:
      "Отзывы пациентов о врачах УрНИИДВиИ в Екатеринбурге. Отзывы о дерматовенерологах и других специалистах института. Ознакомьтесь с отзывами пациентов и оставьте свой отзыв о приеме врача.",
    keywords:
      "отзывы о врачах УрНИИДВиИ, отзывы УрНИИДВиИ, отзывы о врачах Екатеринбург, отзывы пациентов Екатеринбург, отзывы дерматолога Екатеринбург, отзывы дерматовенеролога, врачи УрНИИДВиИ отзывы",
    url: "/patients/reviews",
  },

  newReviews: {
    title: "Оставить отзыв о враче или клинике",
    description:
      "Оставьте отзыв о приеме врача и качестве медицинской помощи в УрНИИДВиИ в Екатеринбурге.",
    keywords:
      "оставить отзыв о враче, оставить отзыв УрНИИДВиИ, отзыв о дерматологе, отзыв о враче Екатеринбург",
    url: "/patients/reviews/new-reviews",
    noindex: true,
  },

  emergencyNumbers: {
    title: "Справочные службы и телефоны",
    description:
      "Контакты регистратуры, медицинских служб и справочные телефоны для пациентов.",
    keywords: "справочные телефоны клиники",
    url: "/patients/emergency-numbers",
    noindex: true,
  },

  contacts: {
    title: "Контакты",
    description: "Контактная информация, адрес, телефоны и схема проезда.",
    keywords: "контакты УрНИИДВиИ, адрес, телефон",
    url: "/contacts",
  },

  papillomaRemoval: {
    title: "Удаление папиллом в Екатеринбурге",
    description:
      "Безопасное удаление папиллом, диагностика кожных новообразований, консультация дерматолога и современные методы лечения.",
    keywords:
      "удаление папиллом Екатеринбург, удалить папиллому, дерматолог новообразования",
    url: "/services/udalenie-papillom",
  },
};

export default seoConfig;
